__turbopack_context__.v({
  "cardTable": "CardTable-module__TLIcmG__cardTable",
  "cardTableInline": "CardTable-module__TLIcmG__cardTableInline",
  "cardTableOverflowing": "CardTable-module__TLIcmG__cardTableOverflowing",
  "cardTableWithSelection": "CardTable-module__TLIcmG__cardTableWithSelection",
});
